export default "__VITE_ASSET__Cv1Xf02L__"